<template>
  <div @click.prevent="handleToggle">
    <div class="flex gap-4">
      <b-checkbox-base :checked="isCheckedInGroup" />
      <div v-if="label" class="label">
        <span class="text-white">{{ props.label }}</span>
        <span v-if="props.description" class="lead">{{ props.description }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { inject } from "vue";
import BCheckboxBase from "./BCheckboxBase.vue";

interface Props {
  value?: string | number | boolean | undefined;
  modelValue?: any;
  onUpdate?: any;
  label?: string;
  name?: string;
  description?: string;
}

const emit = defineEmits(["update:modelValue"]);
const checkboxGroup = inject("checkboxGroup", null);
const props = defineProps<Props>();

const isCheckedInGroup = computed(() => {
  if (checkboxGroup) {
    return checkboxGroup.selected.value.includes(props.value);
  } else {
    if (props.modelValue instanceof Array) {
      return props.modelValue.includes(props.value);
    }
    return props.modelValue;
  }
});

const handleToggle = () => {
  if (checkboxGroup) {
    checkboxGroup.updateValue(props.value);
  } else {
    let model = props.modelValue;
    if (model instanceof Array) {
      // Create new array reference to trigger Vue reactivity
      if (isCheckedInGroup.value) {
        model = model.filter(item => item !== props.value);
      } else {
        model = [...model, props.value];
      }
    } else {
      model = !model;
    }

    emit("update:modelValue", model);
  }
};
</script>
